import { Cell, Pie, Tooltip, PieChart, ResponsiveContainer } from "recharts";
import { useMemo } from "react";
import { Grid, Spin } from "antd";
import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { PieChartData } from "..";

const { useBreakpoint } = Grid;

type Props = {
  loading?: boolean;
  data: PieChartData[];
};

export default function Graph2({ data, loading }: Props) {
  const screens = useBreakpoint();
  const height = useMemo(() => {
    if (screens.xl) return 200;
    if (screens.lg) return 180;
    if (screens.sm) return 200;
    return 150;
  }, [screens]);

  const cells = data.filter((f) => f.value > 0);

  if (loading) {
    return (
      <StyledFlex style={{ justifyContent: "center" }}>
        <Spin />
      </StyledFlex>
    );
  }

  return (
    <StyledFlex
      style={{ height: `${height}px`, width: "-webkit-fill-available" }}
    >
      <ResponsiveContainer>
        <PieChart>
          <Pie
            label
            data={data}
            startAngle={90}
            endAngle={-270}
            dataKey="value"
            cx="50%"
            cy="50%"
            innerRadius="0%"
            outerRadius="72%"
            fill={cells[0]?.color || data[0]?.color}
          >
            {data.map((entry, index) => (
              <Cell key={index} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip
            labelStyle={{ color: "black" }}
            contentStyle={{
              borderRadius: 12,
              borderColor: "#31354188",
              background: "#FFFFFFCA",
            }}
          />
        </PieChart>
      </ResponsiveContainer>
    </StyledFlex>
  );
}
